import { Badge } from "@/components/ui/Feedback";

/** Marks something recorded on this device that the server has not confirmed yet. */
export function PendingTag({
  title = "Saved on this device. It will sync automatically.",
}: {
  title?: string;
}) {
  return (
    <Badge className="gap-1 whitespace-nowrap">
      <span className="size-1.5 rounded-full bg-status-warning" aria-hidden />
      <span title={title}>Pending</span>
    </Badge>
  );
}

/** Next to an account balance that includes the user's own not-yet-synced changes. */
export function BalancePending({ count }: { count?: number }) {
  if (!count) return null;
  return (
    <PendingTag
      title={`Includes ${count} change${count === 1 ? "" : "s"} not yet confirmed by the server. The confirmed figure replaces this after syncing.`}
    />
  );
}
